<script setup lang="ts">
withDefaults(
    defineProps<{
        type?: 'primary' | 'error';
    }>(),
    {
        type: 'primary'
    }
);
</script>
<template>
    <div class="deviation" :class="type">
        <slot />
    </div>
</template>
<style scoped lang="scss">
@include b(deviation) {
    width: 52px;
    height: 24px;
    overflow: hidden;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 2px;
}

@include b(primary) {
    color: var(--q-color-success);
    background: #00bb2c33;
    border-color: var(--q-color-success);
}

@include b(error) {
    color: var(--q-color-danger);
    background: #fc484833;
    border-color: var(--q-color-danger);
}
</style>
